import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  createFaqForLesson,
  getFaqForLesson,
  upgradetoexpertDoubt,
} from "../../../redux/actions/contentPayer";
import DoubtsReply from "./DoubtsReply";
import { addUserActivity } from "../../../redux/actions/profileDetails";
import { discountActivity, userActivity } from "../../../common/constants";
import Gamification from "../../../components/Gamification";
import { useGamification } from "../../../context/GamificationContext";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCoins,
  faDownLeftAndUpRightToCenter,
  faEllipsisVertical,
  faHeadphones,
  faPaperPlane,
  faUpRightAndDownLeftFromCenter,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import DiscountModal from "../../../components/DiscountModal";
import {
  getDiscountByActivity,
  getHighestDiscount,
} from "../../../redux/actions/userActivity";
import {
  askUserDoubt,
  getOtherLearnerDoubts,
  getUserChatHistory,
  getUserDoubtAudio,
} from "../../../redux/actions/doubts";
import { IKImage } from "imagekitio-react";
import "./index.css";
import AudioPlayer from "./AudioPlayer";
import ToggleAudio from "./ToggleAudio";
import useDoubtData from "../../../hooks/useDoubtData";
import { Dialog, Transition } from "@headlessui/react";

export default function Doubts() {
  const { contentId } = useParams();
  const dispatch = useDispatch();
  const [userInput, setUserInput] = useState({ role: "user", content: "" });
  const [conversationList, setConversationList] = useState(null);
  const scrollRef = useRef(null);
  const inputRef = useRef(null);
  const profileDetails = useSelector((store) => store?.profileDetails);
  const [audioEnabled, setAudioEnabled] = useState(false);
  const [openToggleModal, setOpenToggleModal] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [isBlocked, setIsBlocked] = useState(false);
  const [openConversationBox, setOpenConversationBox] = useState(false);
  const isDesktop = window.innerWidth > 758 ? true : false;
  const div1Ref = useRef(null);
  const div2Ref = useRef(null);
  const user_id = useSelector((store)=> store?.profileDetails?.id);
  const navigate = useNavigate();
  const handleClickOutside = (event) => {
    if (
      div1Ref.current && !div1Ref.current.contains(event.target) &&
      div2Ref.current && !div2Ref.current.contains(event.target)
    ) {
      // Perform your action here
     setOpenToggleModal(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [contentId]);

    useEffect(() => {
    if (scrollRef?.current && conversationList!==null && conversationList?.length > 0 ) {scrollRef?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest'
    });}
  }, [conversationList]);

  useEffect(() => {
   user_id &&  dispatch(
      getUserChatHistory(
        contentId,
        (successObj) => {
          if (successObj?.result === "success")
            setConversationList(successObj?.data?.chat_history);
        },
        (errorObj) => {}
      )
    );


    return ()=>{
      setUserInput({ role: "user", content: "" });
      setConversationList(null);
      setAudioEnabled(false);
      setOpenToggleModal(false);
      setPageNum(1);
      setIsBlocked(false);
      setOpenConversationBox(false);

    }
  }, [contentId]);

  function askDoubtHandler() {
    if(!user_id)
      navigate('/login' , {replace : true});
    const doubt = userInput?.content;
    setUserInput({ role: "user", content: "" });
    if (!audioEnabled) {
      const newObj1 = [...conversationList];
      setConversationList((prev) => [
        ...prev,
        { role: "user", content: doubt },
        {
          role: "system",
          content: "",
          isLoading: true,
          image_url:
            "https://assets.learntube.ai/files/Ai%20doubts/Chatbot%20Thinking%20Loading%20Texting%20Ai.gif?updatedAt=1714649449643",
        },
      ]);
      let newObj = [
        ...conversationList,
        { role: "user", content: doubt },
        {
          role: "system",
          content: "",
          isLoading: true,
          image_url:
            "https://assets.learntube.ai/files/Ai%20doubts/Chatbot%20Thinking%20Loading%20Texting%20Ai.gif?updatedAt=1714649449643",
        },
      ];

      dispatch(
        askUserDoubt(
          contentId,
          doubt,
          audioEnabled,
          (successObj) => {
            if (successObj?.result === "success") {
              newObj[newObj.length - 1] = {
                ...newObj[newObj.length - 1],
                isLoading: false,
                content: successObj?.data?.response,
              };
              setConversationList(newObj);
            } else if (successObj?.result === "failed") {
              newObj1.push(
                { role: "user", content: doubt },
                {
                  role: "system",
                  content: "",
                  isLoading: false,
                  isBlocked: true,
                  image_url:
                    "https://assets.learntube.ai/files/Content_player/dizziness%201.gif?updatedAt=1693985316179",
                }
              );
              setConversationList(newObj1);
              setIsBlocked(true);
            }
          },
          (errorObj) => {}
        )
      );
    } else {
      let newObj = [...conversationList];
      let newObj1 = [...conversationList];
      setConversationList((prev) => [
        ...prev,
        { role: "user", content: doubt },
        {
          role: "system",
          content: "",
          isLoading: true,
          type: "text",
          image_url:
            "https://assets.learntube.ai/files/Ai%20doubts/Chatbot%20Thinking%20Loading%20Texting%20Ai.gif?updatedAt=1714649449643",
        },
        {
          role: "system",
          content: "https",
          isLoading: true,
        },
      ]);

      dispatch(
        askUserDoubt(
          contentId,
          doubt,
          audioEnabled,
          (successObj) => {
            if (successObj?.result === "success") {
              newObj.push(
                { role: "user", content: doubt },
                {
                  role: "system",
                  content: successObj?.data?.response,
                  isLoading: false,
                  type: "text",
                },
                {
                  role: "system",
                  content: "https",
                  isLoading: true,
                }
              );
              console.log("newObj", newObj);
              setConversationList(newObj);
              dispatch(
                getUserDoubtAudio(
                  successObj?.data?.uai,
                  (res) => {
                    newObj1.push(
                      { role: "user", content: doubt },
                      {
                        role: "system",
                        content: successObj?.data?.response,
                        isLoading: false,
                        type: "text",
                        image_url:
                          "https://assets.learntube.ai/files/Ai%20doubts/Chatbot%20Thinking%20Loading%20Texting%20Ai.gif?updatedAt=1714649449643",
                      },
                      {
                        role: "system",
                        content: res?.data?.file_url,
                        isLoading: false,
                      }
                    );
                    console.log("newObj1", newObj1);

                    setConversationList(newObj1);
                  },
                  (err) => {}
                )
              );
            } else if (successObj?.result === "failed") {
              newObj1.push(
                { role: "user", content: doubt },
                {
                  role: "system",
                  content: "",
                  isLoading: false,
                  isBlocked: true,
                  image_url:
                    "https://assets.learntube.ai/files/Content_player/dizziness%201.gif?updatedAt=1693985316179",
                }
              );
              setConversationList(newObj1);
              setIsBlocked(true);
            }
          },
          (errorObj) => {}
        )
      );

      // setConversationList((prev)=> ([...prev , userInput]));
    }
  }
  console.log("conversation", conversationList);

  const { usersData, hasNextPage } = useDoubtData(contentId, pageNum);

  console.log("userData", usersData);

  const intObserver = useRef();
  const lastItemRef = useCallback(
    (item) => {
      // if (isLoading) return

      if (intObserver.current) intObserver.current.disconnect();

      intObserver.current = new IntersectionObserver((posts) => {
        if (posts[0].isIntersecting && hasNextPage) {
          console.log("we are near the last item");
          setPageNum((prev) => prev + 1);
        }
      });

      if (item) intObserver.current.observe(item);
    },
    [hasNextPage]
  );

  // const content = usersData.map((item, i)=>{
  //     if (usersData.length === i + 1){
  //         return <UserModal ref={lastItemRef} key={item.id} item={item}/>
  //     }
  //     return <UserModal key={item.id} item={item}/>
  // })
  function getPlan(role_type) {
    if (role_type === "pro") return "LearnTube Pro User";
    else if (role_type === "pro_plus") return "LearnTube Pro+ User";
    else if (role_type === "x") return "LearnTubeX User";
    else if (role_type === "max") return "LearnTube Max User";

    return "Power Learner";
  }


  const topics = [{id:1 , keyword: "Explore" , description : "Explore more about this topic"} , {id:2 , keyword: "Simplify" , description : "Get a simpler explanation for this topic"} , {id:3 , keyword: "Examples" , description : "Get some examples related to this topic"}]
 
  return (
    <div className="my-4 flex w-full  flex-col px-1 md:px-0">
      <div
        className={`mt-0  flex w-full flex-col items-center justify-start rounded-xl border-2 doubt-parent-box-shadow`}
      >
        <div className="relative flex w-full items-center justify-between border-b-2 p-2 md:p-3 ">
          <h1 className="text-[20px] font-semibold md:text-[28px]">
            Ask Doubts
          </h1>
         
          <div className="flex items-center gap-4 justify-center">
            <div
              className={`box-border flex shrink-0 grow-0 basis-auto flex-row items-center justify-center rounded-xl pl-[6.25px] pr-1.5 [background:linear-gradient(180.00deg,#1f90cf_100.00%,#84d3ff_0.00%)]`}
            >
              <img
                urlEndpoint="https://assets.learntube.ai/files/"
                src="https://assets.learntube.ai/files/Content_player/Group%209043.svg?updatedAt=1693982363150"
                className=""
                transformation={[
                  {
                    height: "160",
                    width: "160",
                  },
                ]}
              />
              <p
                className={`ml-[3.25px] box-border flex shrink-0 grow-0 basis-auto flex-row items-center justify-center font-semibold text-[white]`}
              >
                <span
                  className={`text-[12px] md:text-[18.5px] learntube-font-family`}
                >
                  LearnTube
                </span>
                <span
                  className={` mr-2 text-[12px] font-normal uppercase md:text-[18.5px] x-font-family`}
                >
                  X
                </span>
                <span
                  className={`text-[12px] md:text-[18.5px] learntube-font-family`}
                >
                  {" "}
                  Feature
                </span>
              </p>
            </div>
            {!isDesktop && <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter}  onClick={(e) => setOpenConversationBox(true)}/>}
            <div className="" ref={div1Ref}>
              <FontAwesomeIcon
                icon={faEllipsisVertical}
                size="xl"
                className="cursor-pointer"
                onClick={(e) => setOpenToggleModal((prev) => !prev)}
              />
            </div>
            {openToggleModal && (
              <div
                className="audio-card-shadow absolute -bottom-10 -right-1 z-[99999] flex items-center justify-center gap-2 rounded-xl   bg-white p-2"
                ref={div2Ref}
              >
                <FontAwesomeIcon icon={faHeadphones} />
                <span className="text-[14px] font-medium">Include Audio</span>
                <ToggleAudio
                  isToggle={audioEnabled}
                  setIsToggle={setAudioEnabled}
                />
              </div>
            )}
          </div>
        </div>

        <form
          className="w-full"
          onSubmit={(e) => {
            e.preventDefault();
            // askDoubtHandler();
          }}
        >
          <div
            className={`${
              isDesktop ? (userInput?.content?.length > 100 ? "h-[340px]" : "h-[400px]") : ( userInput?.content?.length > 40 ? "h-[340px]" : "h-[400px]")
            } ${conversationList?.length == 0 && 'flex flex-col justify-end items-start'} relative w-full overflow-y-scroll`}
            style={{
              backgroundImage: `url('https://assets.learntube.ai/files/Ai%20doubts/blue-bg.png?updatedAt=1714646388749')`,
              // borderRadius: "30px",
              width: "100%",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          >
            {conversationList?.length == 0 ? 
            <div className=" w-full grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-0 p-2">
             {topics?.map((item ,index)=> <div className="md:w-[98%] bg-[#FFFFFF] rounded-2xl p-4 bg-opacity-70 cursor-pointer" onClick={(e)=> {
               if(inputRef?.current){
               inputRef?.current?.focus();
               inputRef?.current?.scrollIntoView();
               }
               setUserInput((prev) => ({
                 ...prev,
                 content: item?.keyword,
               }));
             }} >
              <div className="text-[14px] md:text-[18px] font-medium">{item?.keyword}</div>
              <div className="text-[#666666] text-[12px] md:text-[14px]">{item?.description}</div>
             </div>)}
            </div>
            :
            <div className="flex w-full flex-col gap-4 p-2">
              {conversationList?.map((item, index) =>
                item?.role === "user" ? (
                  <div className={`flex w-full flex-row-reverse items-end`}>
                    {profileDetails?.profile_image ? (
                      <div className={` ml-2 ${window.innerWidth > 758 ? 'w-[44px] h-[44px]' : 'w-[32px] h-[32px]'}`}> <img
                      src={profileDetails?.profile_image}
                      className=" rounded-full w-full h-full object-fit"
                      alt="profile image"
                      width={32}
                      height={32}
                    /></div>
                     
                    ) : (
                      <FontAwesomeIcon
                        className="ml-2 text-slate-600"
                        width={32}
                        height={32}
                        icon={faUserCircle}
                      />
                    )}
                    <div
                      className="doubt-parent-box-shadow max-w-[80%] rounded-xl bg-[#1F90CF] p-2  text-[14px] md:text-[18px] text-white"
                    >
                      {item?.content}
                    </div>
                  </div>
                ) : (
                  <div className={`flex w-full flex-row `}>
                    <div
                      className="doubt-parent-box-shadow flex max-w-[80%] flex-col items-center justify-center rounded-xl bg-white p-2 text-[14px] text-black "
                    >
                      {item?.isBlocked === true ? (
                        <div className="flex w-full flex-col items-center justify-center self-center">
                          <img
                            urlEndpoint="https://assets.learntube.ai/files/"
                            src={item?.image_url}
                            width={108}
                            height={108}
                            transformation={[
                              {
                                height: "160",
                                width: "160",
                              },
                            ]}
                          />
                          <div className="px-4 text-center text-[14px]  md:text-[16px]">
                            You’ve
                            <span className="text-[#FF2633]"> Exhausted </span>
                            All Your Notes Generation.
                            <span className="font-semibold">
                              {" "}
                              Upgrade To LearnTubeX
                            </span>{" "}
                            to Enjoy Unlimited Notes Generation!
                          </div>
                        </div>
                      ) : !item?.content?.startsWith("https") ? (
                        item?.isLoading === true ? (
                          <div className="flex w-[232px] md:w-[614px] items-center justify-center">
                            <img
                              urlEndpoint="https://assets.learntube.ai/files/"
                              src="https://assets.learntube.ai/files/Ai%20doubts/Chatbot%20Thinking%20Loading%20Texting%20Ai.gif?updatedAt=1714649449643"
                              width={108}
                              height={108}
                              transformation={[
                                {
                                  height: "160",
                                  width: "160",
                                },
                              ]}
                            />
                          </div>
                        ) : (
                          <span className="text-[14px] md:text-[18px] ">{item?.content}</span>
                        )
                      ) : item?.isLoading === true ? (
                        <div className="w-[200px] md:w-[600px]  items-center justify-center px-1 py-4">
                          <div className="h-[2px] w-full bg-[#1CA571]" />
                        </div>
                      ) : (
                        <div className="w-[200px] md:w-[600px]">
                          <AudioPlayer src={item?.content} />
                        </div>
                      )}
                    </div>
                  </div>
                )
              )}
            </div>}

            {conversationList!==null && conversationList?.length > 0 && <div className="bottom-area " ref={scrollRef}></div>}
          </div>
          {isBlocked === false ? <div className="flex w-full justify-between items-center rounded-b-xl bg-white p-2 md:p-3">
            <textarea
              id="multiline-input"
              className={`flex-1    ${
                isDesktop ? (userInput?.content?.length > 100 ? "h-[100px]" : "h-[45px]") : (userInput?.content?.length > 100 ? "h-[100px]" : "h-[45px]")
              } item block rounded-lg border-2 border-[#1CA571] p-2 focus:border-[#1CA571]`}
              contentEditable="true"
              ref={inputRef}
              type="text"
              placeholder="Ask your question"
              value={userInput?.content}
              onClick={(e) => inputRef?.current?.focus()}
              onChange={(e) => {
                inputRef?.current?.focus();
                setUserInput((prev) => ({ ...prev, content: e?.target.value }));
              }}
            />
            <div className="p-2 md:px-4">
              <FontAwesomeIcon
                icon={faPaperPlane}
                size="xl"
                className={`cursor-pointer text-[#1CA571] ${userInput?.content?.length === 0 && 'opacity-50'}`}
                onClick={askDoubtHandler}
              />
            </div>
          </div> : 
          <div className="flex w-full  items-center bg-white p-2">
              <button
              className="upgrade-button flex items-center rounded-lg justify-center w-full h-[45px] text-[14px] font-semibold text-white md:text-[18px]"
              onClick={(e) => window.open("/pricing", "_blank")}
            >
              <img
                urlEndpoint="https://assets.learntube.ai/files/"
                src="https://assets.learntube.ai/files/Content_player/Group%209045.svg?updatedAt=1693995597919"
                className="mr-1 h-[20px] w-[20px]"
                transformation={[
                  {
                    height: "160",
                    width: "160",
                  },
                ]}
              />
              Upgrade To LearnTubeX
            </button>
            </div>
        }
        </form>
      </div>

      {usersData?.length > 0 && (
        <div className="my-4 md:my-6 flex w-full flex-col">
          <h1 className="mb-2 text-[20px] font-semibold md:text-[28px]">
            All Doubts
          </h1>
          {
           isDesktop ?
           <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2 md:gap-4 ">
              {usersData?.map((item, i) =>
                usersData?.length === i + 1 ? (
                  <div
                    ref={lastItemRef}
                    key={i}
                    className={`relative flex  w-full flex-col items-start justify-center overflow-hidden  rounded-xl p-4 shadow-lg md:p-4`}
                    style={{
                      backgroundImage: `url('https://assets.learntube.ai/files/Ai%20notes/Rectangle%205247.png?updatedAt=1713952216423')`,
                      borderRadius: "20px",
                      width: "100%",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                    }}
                  >
                    {" "}
                    <div className={"w-full"}>
                      <div className="w-full flex flex-col">
                        <div className="flex w-full items-center justify-start">
                          <div className="relative mr-2 ">
                          {item?.profile_image ? <div className={`${window.innerWidth > 758 ? 'w-[52px] h-[52px]' : 'w-[48px] h-[48px]'}`}> <img
                                src={item?.profile_image}
                                alt="profile image"
                                className="rounded-full w-full h-full object-fit"
            
                              ></img></div> :
                              <FontAwesomeIcon
                              className="text-slate-600"
                              icon={faUserCircle}
                              size={window.innerWidth > 758 ? '3x' : '3x'}
                              />}
                            {item?.user_role !== 1 && item?.user_role !== 7 && (
                              <img
                                urlEndpoint="https://assets.learntube.ai/files/"
                                src={`https://assets.learntube.ai/files/skill_page/pro.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660918183860`}
                                className="absolute bottom-0 right-0 h-4 w-4 rounded-full"
                                transformation={[
                                  {
                                    height: "60",
                                    width: "60",
                                  },
                                ]}
                              />
                            )}
                            
                          </div>
                          <div className="flex flex-col leading-tight items-start justify-center">
                              <div className="text-[16px] font-semibold md:text-[18px]">
                                {item?.name?.split(" ")?.[0]}
                              </div>
                              <div className="text-[14px] text-[#A8A6AC] md:text-[16px]">
                                {getPlan(item?.role_type)}
                              </div>
                            </div>
                        </div>
                         <div className="flex w-full flex-col items-start justify-start leading-tight">
                            
                            <div className="mt-4 text-[14px] font-medium">
                              {item?.doubt}
                            </div>
                            <div className="mt-4 flex w-full items-center justify-end relative">
                            <button
                              className="rounded-3xl border-2 border-[#1CA571] py-2 px-4 text-[12px] font-semibold text-[#1CA571]"
                              onClick={(e) => {
                                if(!user_id)
                                  navigate('/login' , {replace : true});
                                if(inputRef?.current){
                                  inputRef?.current?.focus();
                                  inputRef?.current?.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center',
                                    inline: 'nearest'
                                  });
                              }
                                setUserInput((prev) => ({
                                  ...prev,
                                  content: item?.doubt,
                                }));
                              }}
                            >
                              Ask This Doubt
                            </button>
                            <div className="absolute text-[10px] font-semibold rounded-full w-[12px] h-[12px] text-center text-white top-0 right-0 bg-[#1CA571]">{item?.count}</div>
                          </div>
                          </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                  key={i}
                  className={`relative flex  w-full flex-col items-start justify-center overflow-hidden  rounded-xl p-4 shadow-lg md:p-4`}
                  style={{
                    backgroundImage: `url('https://assets.learntube.ai/files/Ai%20notes/Rectangle%205247.png?updatedAt=1713952216423')`,
                    borderRadius: "20px",
                    width: "100%",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                >
                  {" "}
                  <div className={"w-full"}>
                    <div className="w-full flex flex-col">
                      <div className="flex w-full items-center justify-start">
                        <div className="relative mr-2 ">
                        {item?.profile_image ? <div className={`${window.innerWidth > 758 ? 'w-[52px] h-[52px]' : 'w-[48px] h-[48px]'}`}> <img
                                src={item?.profile_image}
                                alt="profile image"
                                className="rounded-full w-full h-full object-fit"
            
                              ></img></div> :
                              <FontAwesomeIcon
                              className="text-slate-600"
                              icon={faUserCircle}
                              size={window.innerWidth > 758 ? '3x' : '3x'}
                              />}
                          {item?.user_role !== 1 && item?.user_role !== 7 && (
                            <img
                              urlEndpoint="https://assets.learntube.ai/files/"
                              src={`https://assets.learntube.ai/files/skill_page/pro.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660918183860`}
                              className="absolute bottom-0 right-0 h-4 w-4 rounded-full"
                              transformation={[
                                {
                                  height: "60",
                                  width: "60",
                                },
                              ]}
                            />
                          )}
                          
                        </div>
                        <div className="flex flex-col leading-tight items-start justify-center">
                            <div className="text-[16px] font-semibold md:text-[18px]">
                              {item?.name?.split(" ")?.[0]}
                            </div>
                            <div className="text-[14px] text-[#A8A6AC] md:text-[16px]">
                              {getPlan(item?.role_type)}
                            </div>
                          </div>
                      </div>
                       <div className="flex w-full flex-col items-start justify-start leading-tight">
                          
                          <div className="mt-4 text-[14px] font-medium">
                            {item?.doubt}
                          </div>
                          <div className="mt-4 flex w-full items-center justify-end relative">
                            <button
                              className="rounded-3xl border-2 border-[#1CA571] py-2 px-4 text-[12px] font-semibold text-[#1CA571]"
                              onClick={(e) => {
                                if(!user_id)
                                  navigate('/login' , {replace : true});
                                  if(inputRef?.current){
                                  inputRef?.current?.focus();
                                  inputRef?.current?.scrollIntoView({
                                  behavior: 'smooth',
                                  block: 'center',
                                  inline: 'nearest'
                                });
                              }
                                setUserInput((prev) => ({
                                  ...prev,
                                  content: item?.doubt,
                                }));
                              }}
                            >
                              Ask This Doubt
                            </button>
                            <div className="absolute text-[10px] font-semibold rounded-full w-[12px] h-[12px] text-center text-white top-0 right-0 bg-[#1CA571]">{item?.count}</div>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
                )
              )}
            </div>
             : <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2 md:gap-4 ">
              {usersData?.map((item, i) =>
                usersData?.length === i + 1 ? (
                  <div
                    ref={lastItemRef}
                    key={i}
                    className={`relative flex  w-full flex-col items-start justify-center overflow-hidden  rounded-xl p-4 shadow-lg md:p-4`}
                    style={{
                      backgroundImage: `url('https://assets.learntube.ai/files/Ai%20notes/Rectangle%205247.png?updatedAt=1713952216423')`,
                      borderRadius: "20px",
                      width: "100%",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                    }}
                  >
                    {" "}
                    <div className={"w-full"}>
                      <div className="w-full">
                        <div className="flex w-full items-start justify-start">
                          <div className="relative mr-2 ">
                          {item?.profile_image ? <div className={`${window.innerWidth > 758 ? 'w-[52px] h-[52px]' : 'w-[48px] h-[48px]'}`}> <img
                                src={item?.profile_image}
                                alt="profile image"
                                className="rounded-full w-full h-full object-fit"
            
                              ></img></div> :
                              <FontAwesomeIcon
                              className="text-slate-600"
                              icon={faUserCircle}
                              size={window.innerWidth > 758 ? '3x' : '3x'}
                              />}
                            {item?.user_role !== 1 && item?.user_role !== 7 && (
                              <img
                                urlEndpoint="https://assets.learntube.ai/files/"
                                src={`https://assets.learntube.ai/files/skill_page/pro.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660918183860`}
                                className="absolute bottom-0 right-0 h-4 w-4 rounded-full"
                                transformation={[
                                  {
                                    height: "60",
                                    width: "60",
                                  },
                                ]}
                              />
                            )}
                          </div>
                          <div className="flex w-full flex-col items-start justify-start leading-tight">
                            <div className="flex items-center justify-center gap-2">
                              <div className="text-[16px] font-semibold md:text-[18px]">
                                {item?.name?.split(" ")?.[0]}
                              </div>
                              <div className="text-[14px] text-[#A8A6AC] md:text-[16px]">
                                {getPlan(item?.role_type)}
                              </div>
                            </div>
                            <div className="mt-2 text-[14px] font-medium">
                              {item?.doubt}
                            </div>
                            <div className="mt-2 flex w-full items-center justify-end relative">
                              <button
                                className="rounded-3xl border-2 border-[#1CA571] py-2 px-4 text-[12px] font-semibold text-[#1CA571]"
                                onClick={(e) => {
                                  if(!user_id)
                                    navigate('/login' , {replace : true});
                                  if(inputRef?.current){
                                  inputRef?.current?.focus();
                                  inputRef?.current?.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center',
                                    inline: 'nearest'
                                  });
                                }
                                  setUserInput((prev) => ({
                                    ...prev,
                                    content: item?.doubt,
                                  }));
                                }}
                              >
                                Ask This Doubt
                              </button>
                              <div className="absolute text-[10px] font-semibold rounded-full w-[12px] h-[12px] text-center text-white top-0 right-0 bg-[#1CA571]">{item?.count}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    key={i}
                    className={`relative flex  w-full flex-col items-start justify-center overflow-hidden  rounded-lg p-3 shadow-lg md:p-4`}
                    style={{
                      backgroundImage: `url('https://assets.learntube.ai/files/Ai%20notes/Rectangle%205247.png?updatedAt=1713952216423')`,
                      borderRadius: "20px",
                      width: "100%",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                    }}
                  >
                    <div className="w-full">
                      <div className="flex w-full items-start justify-start">
                        <div className="relative mr-2 ">
                        {item?.profile_image ? <div className={`${window.innerWidth > 758 ? 'w-[52px] h-[52px]' : 'w-[48px] h-[48px]'}`}> <img
                                src={item?.profile_image}
                                alt="profile image"
                                className="rounded-full w-full h-full object-fit"
            
                              ></img></div> :
                              <FontAwesomeIcon
                              className="text-slate-600"
                              icon={faUserCircle}
                              size={window.innerWidth > 758 ? '3x' : '3x'}
                              />}
                          {item?.user_role !== 1 && item?.user_role !== 7 && (
                            <img
                              urlEndpoint="https://assets.learntube.ai/files/"
                              src={`https://assets.learntube.ai/files/skill_page/pro.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660918183860`}
                              className="absolute bottom-0 right-0 h-4 w-4 rounded-full"
                              transformation={[
                                {
                                  height: "60",
                                  width: "60",
                                },
                              ]}
                            />
                          )}
                        </div>
                        <div className="flex w-full flex-col items-start justify-start leading-tight">
                          <div className="flex items-center justify-center gap-2">
                            <div className="text-[16px] font-semibold md:text-[18px]">
                              {item?.name?.split(" ")?.[0]}
                            </div>
                            <div className="text-[14px] text-[#A8A6AC] md:text-[16px]">
                              {getPlan(item?.role_type)}
                            </div>
                          </div>
                          <div className="mt-2 text-[14px] font-medium">
                            {item?.doubt}
                          </div>
                          <div className="mt-2 flex w-full items-center justify-end relative">
                              <button
                                className="rounded-3xl border-2 border-[#1CA571] py-2 px-4 text-[12px] font-semibold text-[#1CA571]"
                                onClick={(e) => {
                                  if(!user_id)
                                    navigate('/login' , {replace : true});
                                  if(inputRef?.current){
                                  inputRef?.current?.focus();
                                  inputRef?.current?.scrollIntoView({
                                    behavior: 'smooth',
                                      block: 'center',
                                      inline: 'nearest'
                                    });
                                  }
                                  setUserInput((prev) => ({
                                    ...prev,
                                    content: item?.doubt,
                                  }));
                                }}
                              >
                                Ask This Doubt
                              </button>
                              <div className="absolute text-[10px] font-semibold rounded-full w-[12px] h-[12px] text-center text-white top-0 right-0 bg-[#1CA571]">{item?.count}</div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          }
        </div>
      )}

<Transition
        show={openConversationBox}
        enter="duration-500 ease-out"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="duration-300 ease-out"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
    <Dialog
    onClose={()=> null}
    // onClose={() =>
    //     // setDiscountModal(prev => ({ ...prev, open: false, data: null }))
    // }
    as="div"
    style={{ zIndex: '9999999999' }}
    className="fixed inset-0 z-10  flex md:justify-start md:mt-20 justify-center flex-col items-center">
    <Dialog.Overlay className="fixed inset-0 bg-black opacity-0 z-10" />
    <Dialog.Title />
    <Dialog.Description />
    <div className="h-full w-full z-[999999999999] flex flex-col">
      <div className="relative flex w-full  bg-white items-center justify-between border-b-2 p-2 md:p-3 ">
          <div className="text-[20px] font-semibold md:text-[28px]">
            Ask Doubts
          </div>
          <div className="flex items-center justify-center gap-4">
            <div
              className={`box-border flex shrink-0 grow-0 basis-auto flex-row items-center justify-center rounded-xl pl-[6.25px] pr-1.5 [background:linear-gradient(180.00deg,#1f90cf_100.00%,#84d3ff_0.00%)]`}
            >
              <img
                urlEndpoint="https://assets.learntube.ai/files/"
                src="https://assets.learntube.ai/files/Content_player/Group%209043.svg?updatedAt=1693982363150"
                className=""
                transformation={[
                  {
                    height: "160",
                    width: "160",
                  },
                ]}
              />
              <p
                className={`ml-[3.25px] box-border flex shrink-0 grow-0 basis-auto flex-row items-center justify-center font-semibold text-[white]`}
              >
                <span
                  className={`text-[12px] md:text-[18.5px] learntube-font-family`}
                >
                  LearnTube
                </span>
                <span
                  className={` mr-2 text-[12px] font-normal uppercase md:text-[18.5px] x-font-family `}
                >
                  X
                </span>
                <span
                  className={`text-[12px] md:text-[18.5px] learntube-font-family`}
                >
                  {" "}
                  Feature
                </span>
              </p>
            </div>
            <FontAwesomeIcon icon={faDownLeftAndUpRightToCenter} onClick={(e) => setOpenConversationBox(false)}/>
            <div className="">
              <FontAwesomeIcon

                icon={faEllipsisVertical}
                onClick={(e) => setOpenToggleModal((prev) => !prev)}
              />
            </div>
            {openToggleModal && (
              <div
                className="audio-card-shadow absolute -bottom-10 -right-1 z-[99999] flex items-center justify-center gap-2 rounded-xl   bg-white p-2"
              >
                <FontAwesomeIcon icon={faHeadphones} />
                <span className="text-[14px] font-medium">Include Audio</span>
                <ToggleAudio
                  isToggle={audioEnabled}
                  setIsToggle={setAudioEnabled}
                />
              </div>
            )}
          </div>
      </div>
      <div
        className={`doubt-parent-box-shadow mt-0 flex flex-1 w-full flex-col overflow-y-auto bg-white items-center justify-start rounded-xl border-2`}
      >
        

        <form
          className="w-full h-full"
          onSubmit={(e) => {
            e.preventDefault();
            // askDoubtHandler();
          }}
        >
          <div
            className={`${'h-full'
            } ${conversationList?.length == 0 && 'flex flex-col justify-end items-start'} relative w-full overflow-y-scroll`}
            style={{
              backgroundImage: `url('https://assets.learntube.ai/files/Ai%20doubts/blue-bg.png?updatedAt=1714646388749')`,
              // borderRadius: "30px",
              width: "100%",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          >
            {conversationList?.length == 0 ? 
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2 p-2">
             {topics?.map((item ,index)=> <div className=" bg-[#FFFFFF] rounded-2xl p-4 bg-opacity-70" onClick={(e)=> {
              if(inputRef?.current){
               inputRef?.current?.focus();
               inputRef?.current?.scrollIntoView();
              }
               setUserInput((prev) => ({
                 ...prev,
                 content: item?.keyword,
               }));
             }} >
              <div className="text-[14px] font-medium">{item?.keyword}</div>
              <div className="text-[#666666] text-[12px]">{item?.description}</div>
             </div>)}
            </div>
            :
            <div className="flex w-full flex-col gap-4 p-2">
              {conversationList?.map((item, index) =>
                item?.role === "user" ? (
                  <div className={`flex w-full flex-row-reverse items-end`}>
                    {profileDetails?.profile_image ? (
                       <div className={` ml-2 ${window.innerWidth > 758 ? 'w-[44px] h-[44px]' : 'w-[32px] h-[32px]'}`}> <img
                       src={profileDetails?.profile_image}
                       alt="profile image"
                       className=" rounded-full w-full h-full object-fit"
                       width={32}
                       height={32}
                     /></div>
                    ) : (
                      <FontAwesomeIcon
                        className="ml-2 text-slate-600"
                        width={32}
                        height={32}
                        icon={faUserCircle}
                      />
                    )}
                    <div
                      className="doubt-parent-box-shadow max-w-[80%] rounded-xl bg-[#1F90CF] p-2  text-[14px] text-white"
                    >
                      {item?.content}
                    </div>
                  </div>
                ) : (
                  <div className={`flex w-full flex-row `}>
                    <div
                      className="doubt-parent-box-shadow flex max-w-[80%] flex-col items-center justify-center rounded-xl bg-white p-2 text-[14px] text-black "
                    >
                      {item?.isBlocked === true ? (
                        <div className="flex w-full flex-col items-center justify-center self-center">
                          <img
                            urlEndpoint="https://assets.learntube.ai/files/"
                            src={item?.image_url}
                            width={108}
                            height={108}
                            transformation={[
                              {
                                height: "160",
                                width: "160",
                              },
                            ]}
                          />
                          <div className="px-4 text-center text-[14px]  md:text-[16px]">
                            You’ve
                            <span className="text-[#FF2633]"> Exhausted </span>
                            All Your Notes Generation.
                            <span className="font-semibold">
                              {" "}
                              Upgrade To LearnTubeX
                            </span>{" "}
                            to Enjoy Unlimited Notes Generation!
                          </div>
                        </div>
                      ) : !item?.content?.startsWith("https") ? (
                        item?.isLoading === true ? (
                          <div className="flex w-[232px] items-center justify-center">
                            <img
                              urlEndpoint="https://assets.learntube.ai/files/"
                              src="https://assets.learntube.ai/files/Ai%20doubts/Chatbot%20Thinking%20Loading%20Texting%20Ai.gif?updatedAt=1714649449643"
                              width={108}
                              height={108}
                              transformation={[
                                {
                                  height: "160",
                                  width: "160",
                                },
                              ]}
                            />
                          </div>
                        ) : (
                          <span>{item?.content}</span>
                        )
                      ) : item?.isLoading === true ? (
                        <div className="w-[200px] items-center justify-center px-1 py-4">
                          <div className="h-[2px] w-full bg-[#1CA571]" />
                        </div>
                      ) : (
                        <AudioPlayer src={item?.content} />
                      )}
                    </div>
                  </div>
                )
              )}
            </div>}

            <div className="bottom-area" ref={scrollRef}></div>
          </div>
        </form>
      </div>
      {isBlocked === false ? <div className="flex w-full  items-center bg-white p-2 ">
            <textarea
              id="multiline-input"
              className={`w-[90%]    ${
                userInput?.content?.length > 40 ? "h-[100px]" : "h-[45px]"
              } item block rounded-lg border-2 border-[#1CA571] p-2 focus:border-[#1CA571]`}
              contentEditable="true"
              ref={inputRef}
              type="text"
              placeholder="Ask your question"
              value={userInput?.content}
              onClick={(e) => inputRef?.current?.focus()}
              onChange={(e) => {
                inputRef?.current?.focus();
                setUserInput((prev) => ({ ...prev, content: e?.target.value }));
              }}
            />
            <div className="p-2">
              <FontAwesomeIcon
                icon={faPaperPlane}
                size="xl"
                className={`cursor-pointer text-[#1CA571] ${userInput?.content?.length === 0 && 'opacity-50'}`}
                onClick={askDoubtHandler}
              />
            </div>
          </div> : 
          <div className="flex w-full  items-center bg-white p-2">
              <button
              className="upgrade-button flex items-center rounded-lg justify-center w-full h-[45px] text-[14px] font-semibold text-white md:text-[18px]"
              onClick={(e) => window.open("/pricing", "_blank")}
            >
              <img
                urlEndpoint="https://assets.learntube.ai/files/"
                src="https://assets.learntube.ai/files/Content_player/Group%209045.svg?updatedAt=1693995597919"
                className="mr-1 h-[20px] w-[20px]"
                transformation={[
                  {
                    height: "160",
                    width: "160",
                  },
                ]}
              />
              Upgrade To LearnTubeX
            </button>
            </div>
        }
    </div>
    </Dialog>
    </Transition>
    </div>
  );
}
